//#region react import
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
//#endregion

//#region component import
import GstaToolTip from "../../../Components/GstaToolTip/GstaToolTip.component";
//#endregion

//#region store import
import { setSelectedTrainingId } from "../../../ReduxStore/trainingSlice";
//#endregion

//#region functions import
import { getTrainingImagePath } from "../../../Helper/GetMachineSource";
import { FORMAT_TIMESTRING, formatSecondToStringTime } from "../../../Helper/TimeConverter";
import { getTranslations } from "../../../Helper/TranslationController";
//#endregion

//#region constants import
import { ICON_DELETE, ICON_FLAG, ICON_INFO, ICON_TIMER } from "../../../Constants/IconConstants";
import { TRANSLATIONS } from "../../../Constants/Translations";
import { TRAININGS_DETAILS } from "../../../Routing/PageNames";
//#endregion

//#region style import
import "./TrainingRow.style.scss";
//#endregion

const TrainingRow = ({ training, deleteJourney }) => {
  //#region store
  const translations = useSelector((state) => state.translationSlice.translations);
  const translationsDictionariesToLoad = useSelector((state) => state.translationSlice.translationsDictionariesToLoad);
  const dispatch = useDispatch();
  //#endregion

  //#region functions
  const handleDeleteClick = (e) => {
    e.preventDefault();
    deleteJourney(training.id);
  };

  const handleMoreClick = (e) => {
    e.preventDefault();
    dispatch(setSelectedTrainingId(training.id));
    window.open(TRAININGS_DETAILS.url, "_blank", "noopener,noreferrer");
  };
  //#endregion

  //#region state
  const [image, setImage] = useState();
  //#endregion

  //#region useEffect
  useEffect(() => {
    const getImage = async () => {
      const imageGetted = await getTrainingImagePath(
        training.softwareCode,
        training.pictureFileName,
        training.machineCode,
        translationsDictionariesToLoad
      );
      setImage(imageGetted);
    };
    getImage();
  }, [translationsDictionariesToLoad, training]);
  //#endregion

  return (
    <tr>
      <td>
        <div className="create-student-training-table_column-name">
          <img
            className="journey-image"
            src={image}
            alt={training.machineCode + "_" + training.trainingName}
          />
          <span>{getTranslations(training.trainingName, translations)}</span>
        </div>
      </td>
      <td id={training.id + "_machine"}>
        <div className="display-flex-center text-icon-machine">
          <i className={`icon-${training.machineCode}`} />
          <span>{training.machineCode}</span>
        </div>
      </td>
      <td id={training.id + "_duration"}>
        <div className="display-flex-center text-icon">
          <i className={ICON_TIMER} />
          <span>{formatSecondToStringTime(training.duration, translations, FORMAT_TIMESTRING.HHMM)}</span>
        </div>
      </td>
      <td id={training.id + "_steps"}>
        <div className="display-flex-center text-icon">
          <i className={ICON_FLAG} />
          <span>{training.stepCount}</span>
        </div>
      </td>
      <td id={training.id + "_actions"}>
        <div className="display-flex-center">
          <GstaToolTip toolTipContent={getTranslations("training_layout_training_detail", translations)}>
            <button
              className="gsta-button-outlined"
              onClick={handleMoreClick}
            >
              <i className={ICON_INFO} />
            </button>
          </GstaToolTip>
          <GstaToolTip toolTipContent={getTranslations(TRANSLATIONS.DELETE, translations)}>
            <button
              className="gsta-button-outlined"
              onClick={handleDeleteClick}
            >
              <i
                data-testid={"delete-journey-" + training.id}
                className={ICON_DELETE}
              />
            </button>
          </GstaToolTip>
        </div>
      </td>
    </tr>
  );
};

export default TrainingRow;
